import React from 'react';
import { Animated } from 'react-native';
import { useStyle } from '../styles';
const SLIDER_WIDTH = 20;
const Slider = ({ kidtoken = '', scalable = false, customStyle = {}, type, leftValue, }) => {
    const { style } = useStyle({
        kidtoken,
        scalable,
        customStyle,
    });
    const newLeft = Animated.subtract(leftValue, SLIDER_WIDTH / 2);
    return (React.createElement(Animated.View, { testID: 'slider', style: [
            style.slider,
            {
                transform: [{ translateX: newLeft }],
                width: SLIDER_WIDTH,
            },
            style[`${type}Slider`],
        ] }));
};
export default Slider;
